import AnimatedEllipsis from './AnimatedEllipsis'

export default function LoadingView() {
  return (
    <div style={{ padding: '16px 16px 0' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div
          style={{
            padding: '4px 2px',
            color: 'var(--text-muted)',
            fontSize: '10px',
            letterSpacing: '3px',
          }}
        >
          <AnimatedEllipsis />
        </div>
      </div>
    </div>
  )
}
